import type {
	FilterToParamTransformer,
	ParamToFilterTransformer,
} from '@atlassian/jira-common-directory-v2/src/query-param-adapter/model/index.tsx';
import type {
	Filter,
	Group,
	Owner,
	Project,
} from '@atlassian/jira-filters-main/src/model/index.tsx';
import { toAccountId } from '@atlassian/jira-shared-types/src/general.tsx';

export const filterToParams: FilterToParamTransformer<Filter> = (filter = {}) => ({
	name: filter.query || undefined,
	owner: (filter.owner && filter.owner.accountId) || undefined,
	selectedProject: (filter.project && filter.project.value) || 'anything',
	selectedGroup: (filter.group && filter.group.value) || 'anything',
});

const transformSelectedOwner = (input?: string): Owner | undefined =>
	input ? { accountId: toAccountId(input) } : undefined;

const transformSelectedProject = (input?: string): Project | undefined =>
	input && input !== 'anything'
		? {
				value: input,
			}
		: undefined;

const transformSelectedGroup = (input?: string): Group | undefined =>
	input && input !== 'anything'
		? {
				value: input,
				name: input,
			}
		: undefined;

export const filterFromParams: ParamToFilterTransformer<Filter> = (params) => ({
	query: params.name || params.searchName || undefined,
	owner: transformSelectedOwner(params.owner),
	project: transformSelectedProject(params.selectedProject),
	group: transformSelectedGroup(params.selectedGroup),
});
